import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useSettingFaireDirectSignupModalRefresh } from "@faire/retailer-visitor-shared/settings/useSettingFaireDirectSignupModalRefresh";
import { useSettingSignupCta, useAssignSettingSignupCta } from "@faire/retailer-visitor-shared/settings/useSettingSignupCta";
import { Button } from "@faire/web--source/slate/Button";
import { Lock } from "@faire/web--source/slate/icons/foundation/Lock";
import { Row } from "@faire/web--source/slate/Layout";
import { Spacer } from "@faire/web--source/slate/spacing";
import { StrictLocalMsg } from "@faire/web--source/ui/lib/localization";
import { IFourVariantXP } from "@faire/web-api--source/indigofair/settings/IFourVariantXP";
import React, { useEffect } from "react";
export var SignUpCTA = function(param) {
    var disabled = param.disabled, handleSubmit = param.handleSubmit, isFaireDirect = param.isFaireDirect;
    var isFaireDirectSignupRefresh = useSettingFaireDirectSignupModalRefresh();
    var faireDirectSignupCopy = isFaireDirectSignupRefresh ? /*#__PURE__*/ _jsx(SignUpForFreeMessage, {}) : /*#__PURE__*/ _jsx(StrictLocalMsg, {
        id: "rH10ZG",
        defaultMessage: [
            {
                type: 0,
                value: "Sign up"
            }
        ]
    });
    return /*#__PURE__*/ _jsx(Button, {
        onClick: handleSubmit,
        "data-test-id": "createAccountButton",
        style: {
            width: "100%"
        },
        disabled: disabled,
        variant: "primary",
        children: isFaireDirect ? faireDirectSignupCopy : /*#__PURE__*/ _jsx(NonFaireDirectSignupCopy, {})
    });
};
var NonFaireDirectSignupCopy = function() {
    var assignSettingSignupCta = useAssignSettingSignupCta();
    useEffect(function() {
        assignSettingSignupCta();
    }, [
        assignSettingSignupCta
    ]);
    var signupCtaVariant = useSettingSignupCta();
    switch(signupCtaVariant){
        case IFourVariantXP.Bucket.VARIANT_2:
            return /*#__PURE__*/ _jsxs(Row, {
                align: "center",
                children: [
                    /*#__PURE__*/ _jsx(Lock, {
                        lockType: "foundation",
                        fontSize: 16
                    }),
                    /*#__PURE__*/ _jsx(Spacer, {
                        width: 6
                    }),
                    /*#__PURE__*/ _jsx(StrictLocalMsg, {
                        id: "FAM4W4",
                        defaultMessage: [
                            {
                                type: 0,
                                value: "Secure signup"
                            }
                        ]
                    })
                ]
            });
        case IFourVariantXP.Bucket.VARIANT_3:
            return /*#__PURE__*/ _jsx(StrictLocalMsg, {
                id: "1dPMTV",
                defaultMessage: [
                    {
                        type: 0,
                        value: "Sign up to see more"
                    }
                ]
            });
        case IFourVariantXP.Bucket.VARIANT_4:
            return /*#__PURE__*/ _jsxs(Row, {
                align: "center",
                children: [
                    /*#__PURE__*/ _jsx(Lock, {
                        lockType: "foundation",
                        fontSize: 16
                    }),
                    /*#__PURE__*/ _jsx(Spacer, {
                        width: 6
                    }),
                    /*#__PURE__*/ _jsx(StrictLocalMsg, {
                        id: "1dPMTV",
                        defaultMessage: [
                            {
                                type: 0,
                                value: "Sign up to see more"
                            }
                        ]
                    })
                ]
            });
        case IFourVariantXP.Bucket.CONTROL:
        default:
            return /*#__PURE__*/ _jsx(SignUpForFreeMessage, {});
    }
};
var SignUpForFreeMessage = function() {
    return /*#__PURE__*/ _jsx(StrictLocalMsg, {
        id: "ekYhCW",
        defaultMessage: [
            {
                type: 0,
                value: "Sign up for free"
            }
        ]
    });
};
